export const getIntelistyleRequestBody = (country, partNumber) => {
    const market_id = /(us|ca)/i.test(country) ? 'AM' : 'INTL';
    return {
        product_id: partNumber,
        outfit_restrictions: { market_id },
    };
};
